import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix marker icon issue in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

// Countries to mark
const countries = [
  {
    name: "Shanghai, China",
    lat: 31.224361,
    lng: 121.46917,
  },
  {
    name: "Beijing, China",
    lat: 39.9042,
    lng: 116.4074,
  },
  {
    name: "Omachi Ko, Japan",
    lat: 36.5031,
    lng: 137.8629,
  },
  {
    name: "Tokai Center, Shenzhen, China",
    lat: 22.5431,
    lng: 114.0579,
  },
  {
    name: "Kuala Lumpur, Malaysia",
    lat: 3.139,
    lng: 101.6869,
  },
  {
    name: "Ho Chi Minh City, Vietnam",
    lat: 10.8231,
    lng: 106.6297,
  },
  {
    name: "Hanoi, Vietnam",
    lat: 21.0285,
    lng: 105.8542,
  },
  {
    name: "Singapore",
    lat: 1.3521,
    lng: 103.8198,
  },
  {
    name: "Bangkok, Thailand (Sino-Thai Tower)",
    lat: 13.7563,
    lng: 100.5018,
  },
  {
    name: "Bangkok, Thailand (Lerdpanya Building)",
    lat: 13.7563,
    lng: 100.5018,
  },
  {
    name: "Dhaka, Bangladesh",
    lat: 23.79286270074523,
    lng: 90.40842692148749,
  },
];

const HomeGoogleMapGlobal = () => {
  return (
    <div style={{ width: "100%", height: "60vh", borderRadius: "8px" }}>
      <MapContainer
        center={[24, 110]} // Center of Southeast Asia
        zoom={2.6} // Adjust zoom level
        style={{ height: "100%", width: "100%", borderRadius: "8px" }}
        scrollWheelZoom={false} // Disable scroll zoom
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
        />
        {/* Add markers for each country */}
        {countries.map((country, index) => (
          <Marker
            key={index}
            position={[country.lat, country.lng]}
            title={country.name}
          >
            <Popup>{country.name}</Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default HomeGoogleMapGlobal;
